<template>
  <div class="pt-5">
    <section class="container">
      <div class="kt-portlet">
        <div class="alert alert-primary text-center">
          <h1 class="col">
            Estimado cliente su placa no se encuentra registrada en nuestra base de datos,
            por su seguridad un asesor de servicios se comunicará lo antes posible para
            validar sus datos y continuar con el proceso.<br />
            <br />
            Gracias por preferir <b>KIA</b>
          </h1>
        </div>
      </div>

      <div class="pt-5 d-flex justify-content-around" style="margin-bottom: 1rem">
        <button type="button" class="btn btn-primary btn-font-sm" v-on:click="atras">
          <i class="flaticon2-back"></i>
          Realizar nueva cotización
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "gracias",
  mounted() {
    this.$store.commit("setManteniminetosCotizar", []);
    this.$store.commit("setVehiculo", null);
    this.$store.commit("setHome", null);
    this.$store.commit("setListaBeneficios", []);
  },

  methods: {
    atras: function () {
      this.$router.push({ name: "p1" });
    },
  },
};
</script>

<style scoped></style>
